import { animate, AnimationTriggerMetadata, state, style, transition, trigger } from '@angular/animations';

export function routerTransition(): AnimationTriggerMetadata {
    return fadeInUp();
}

export function fadeInUp(): AnimationTriggerMetadata {
    return trigger('routerTransition', [
        state('void', style({})),
        state('*', style({})),
        transition(':enter', [
            // before 2.1: transition('void => *', [
            style({ transform: 'translateY(1rem)', opacity: '0' }),
            animate('.35s ease-out', style({ transform: 'translateY(0)', opacity: '1' }))
        ])
    ]);
}
